/*
Custom theme-specific code goes here.
*/

jQuery(document).ready(function () {
  var footerTray = jQuery("#js-optional-footer");
  var headerTray = jQuery("#js-optional-header");
  var footerCloseButton = jQuery("#js-footer-close-button");
  var headerCloseButton = jQuery("#js-header-close-button");

  if (sessionStorage.getItem("headerTraySeen") != "shown") {
    headerTray.addClass("is-visible");
  }

  if (sessionStorage.getItem("footerTraySeen") != "shown") {
    footerTray.addClass("is-visible");
  }

  headerCloseButton.click(() => {
    headerTray.removeClass("is-visible");
    sessionStorage.setItem("headerTraySeen", "shown");
  });

  footerCloseButton.click(() => {
    footerTray.removeClass("is-visible");
    sessionStorage.setItem("footerTraySeen", "shown");
  });

  // Add the post id to localStorage to track which posts have been seen.
  var bodyClasses = jQuery.makeArray(jQuery("body")[0].classList);
  var postsSeen = localStorage.getItem("postsSeen");

  if (postsSeen) {
    postsSeen = JSON.parse(postsSeen);
  } else {
    postsSeen = [];
  }

  bodyClasses.forEach((bodyClass) => {
    var classStrings = bodyClass.split("-");

    if (classStrings[0] === "postid" && classStrings[1]) {
      var postId = classStrings[1];

      if (!postsSeen.includes(postId)) {
        postsSeen.push(postId);
        localStorage.setItem("postsSeen", JSON.stringify(postsSeen));
      }
    }
  });

  // Remove seen posts.
  var featuredPostsWrapper = jQuery("#js-featured-posts-wrapper");

  featuredPostsWrapper.find("article").each((i, featuredPost) => {
    var postId = featuredPost.id.split("-")[1];

    if (postId && postsSeen.includes(postId)) {
      featuredPost.remove();
    }
  });

  // Update badge count.
  var numberOfFeaturedPosts = featuredPostsWrapper.find("article").length;
  var badge = jQuery("#js-side-tray-badge");
  badge.text(numberOfFeaturedPosts);

  if (!numberOfFeaturedPosts) {
    badge.addClass("invisible");
    featuredPostsWrapper.append("<p class='padding-top-1 padding-bottom-1'>Nothing new to show.</p>");
  }
});
